import Layout from 'components/Layout';
import {
  IMarkDownContainer,
  MarkDownContainer as MarkDownSection,
} from 'containers/MarkdownContainer';
import { graphql } from 'gatsby';
import React from 'react';
import { IContentWithImage } from 'utils/types';

import { SEO } from '../components/SEO';

const components: {
  MarkDownSection: React.FC<IMarkDownContainer>;
} = {
  MarkDownSection,
};

type Props = {
  data: {
    content: {
      title: string;
      sections: {
        componentName: string;
        headline: string;
        description?: { description: string };
        slug: string;
        title?: string;
        listOfContentWithImages?: IContentWithImage[];
        backgroundColor: string;
        markdownField: {
          childMarkdownRemark?: {
            html: string;
          };
        };
      }[];
    };
  };
};

export const Head = () => <SEO />;

export const consumerHealthDataPrivacyNotice = (props: Props) => {
  const { data } = props;
  const { content } = data;
  const { sections } = content;

  return (
    <Layout>
      {sections.map((section, i: number) => {
        if (components[section.componentName as keyof typeof components]) {
          return React.createElement(
            components[section.componentName as keyof typeof components],
            {
              content: section,
              key: `${section.componentName}-${i}`, // handles the case for duplicate section keys
            },
          );
        }
      })}
    </Layout>
  );
};

export default consumerHealthDataPrivacyNotice;

export const data = graphql`
  query {
    content: contentfulPage(
      pageId: { eq: "EHSConsumerHealthDataPrivacyNotice" }
    ) {
      title
      sections {
        headline
        componentName
        slug
        backgroundColor
        description {
          description
        }
        markdownField {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
